import { render, staticRenderFns } from "./page-top.vue?vue&type=template&id=35e51469&scoped=true"
import script from "./page-top.vue?vue&type=script&lang=js"
export * from "./page-top.vue?vue&type=script&lang=js"
import style0 from "./page-top.vue?vue&type=style&index=0&id=35e51469&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e51469",
  null
  
)

export default component.exports